import { useEffect, useState } from 'react';
import Pdf from '../../../Components/Deliveries/pdf/pdf';
import axiosInstance from '../../../Configuration/axiosInstance';
import DeliveriesTable from '../DeliveriesTable/DeliveriesTable';
import stylez from '../Delivery.module.css';
import { useNavigate } from 'react-router-dom';
import SearchStrip from './SeachStrip/SearchStrip';

const CalculateStock = ()  => {

    const [deliveries, setDeliveries] = useState();
    const [loading, setLoading] = useState(false);
    const [printSelected, setPrintSelected] = useState([]);
    const[show,setShow] = useState(false);
    const [prods,setProds ] = useState([]);
    const [order,setOrder] = useState();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const [searchCriteria, setSearchCriteria] = useState({
      runId: '',
      fromDate: '',
      toDate: '',
    });
    const [products,setProducts] = useState([]);
    const [prodID,setProdID] =useState('');
    const [result,setResult]=useState(0);

    const status = ['Delivered','Pending'];
  
    const navigate = useNavigate();
    const updateDeliveries = (i) => {
      navigate('/updateDeliveries', { state: i });
    };

    const initiateSearch =()=>{
      setLoading(true);
      console.log(fromDate,toDate);
      axiosInstance.get(`delivery?fromDate=${fromDate}&toDate=${toDate}&status=${status}`).then((res) => {
        setDeliveries(res.data.data);
        axiosInstance.get(`products/allproducts`).then((res)=>setProducts(res.data.data));
        setLoading(false);
      });
    }

    // Page indexing
  
   
  
    const handleChecked = (e, id) => {
      if (e.target.checked) {
        setPrintSelected((preValues) => [...preValues, e.target.value]);
      } else if (!e.target.checked) {
        setPrintSelected(printSelected.filter((i) => i !== id));
      }
      // Include the first selected item in the print selection
      const printSelection = [...printSelected];
      if (!printSelection.includes(id)) {
        printSelection.push(id);
      }
    };
  
    const handleProductModal=(products,order)=>{
      setProds(products);
      setOrder(order);
      setShow(true);
    }
  
    const calculateStocks =()=>{
    
     const prdi=  deliveries.map(i=>{
        return i.order.map((o)=>o.products.filter(i=>i.product?._id === prodID.label));
      });

       setResult(prdi.flatMap(i=>i.flatMap(j=>j.map((num)=>num.quantity))).reduce((acc,curr)=>acc+curr,0));
    }

    const headings = [
      'Select',
      'Run Id',
      'Run Name',
      'Order Details',
      'Expected Delivery Date'
    ];

    return (
      <div>
        <div className={stylez.heading}>
          <h2>CalculateStock</h2>
         
          <SearchStrip 
          searchCriteria={searchCriteria}
          setSearchCriteria={setSearchCriteria}
          products={products}
          setProdID={setProdID}
          result={result}
          calculateStocks={calculateStocks}
          initiateSearch={initiateSearch}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        
          />
          
          {/* Implement a search Strip to search for the deliveries using date or RUN ID */}
        </div>        
          <DeliveriesTable
          show={show}
          setShow={setShow}
          order={order}
          prods={prods}
          loading={loading}
          deliveries={deliveries}
          handleChecked={handleChecked}
          handleProductModal={handleProductModal}
          updateDeliveries={updateDeliveries}
          calculateStock={true}
          headings={headings}
          />  
         
      </div>
    );
  };
export default CalculateStock;